var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tracker__base"},[_c('div',{staticClass:"tracker__wrapper"},[_c('Controls'),_c('Patterns')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }